import { locales } from './config'

export const isLocale = tested => locales.some(locale => locale === tested)